var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      style: _vm.tileStyle,
      on: {
        contextmenu: function($event) {
          $event.stopPropagation()
          $event.preventDefault()
          return _vm.showContextMenu($event)
        }
      }
    },
    [
      _c(
        "drop",
        {
          on: {
            drop: _vm.handleStayDrop,
            dragover: function($event) {
              _vm.handleStayDragover.apply(void 0, arguments)
            }
          },
          nativeOn: {
            click: function($event) {
              _vm.showStayDialog()
            }
          }
        },
        [
          _c(
            "v-layout",
            { attrs: { row: "" } },
            [
              _c(
                "v-flex",
                { staticStyle: { overflow: "hidden" } },
                [
                  _c("span", { style: _vm.statusBarStyle }),
                  _c(
                    "span",
                    { staticClass: "clientText", style: _vm.tileStyle },
                    [_vm._v(_vm._s(_vm.clientText))]
                  ),
                  _vm._l(_vm.alerts(), function(code, index) {
                    return _vm.alerts
                      ? _c(
                          "span",
                          { key: index },
                          [
                            _c("alert-visualized-coded-entry", {
                              staticClass: "alert",
                              attrs: {
                                "visualized-coded-entry": code,
                                alertDisplayName: _vm.getAlertDisplayName(code)
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  })
                ],
                2
              ),
              _c(
                "v-flex",
                {
                  staticStyle: { overflow: "hidden" },
                  attrs: { "text-xs-right": "" }
                },
                [
                  _c("div", { staticClass: "attendingPhysicianName" }, [
                    _vm._v(_vm._s(_vm.attendingPhysicianName))
                  ])
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm.isStayDialogVisible
        ? _c(
            "v-dialog",
            {
              attrs: { scrollable: "", "min-height": "95%", width: "800px" },
              model: {
                value: _vm.isStayDialogVisible,
                callback: function($$v) {
                  _vm.isStayDialogVisible = $$v
                },
                expression: "isStayDialogVisible"
              }
            },
            [
              _c(
                "v-flex",
                [
                  _c("stay-card", {
                    attrs: {
                      unit: _vm.unit,
                      room: _vm.room,
                      stay: _vm.stayCopy,
                      isEditable: _vm.unit.isStayEditingAllowed,
                      onCancel: _vm.closeStayDialog,
                      onSave: _vm.saveStay
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm.isSwapDialogVisible
        ? _c(
            "v-dialog",
            {
              attrs: { scrollable: "", height: "300px", width: "500px" },
              model: {
                value: _vm.isSwapDialogVisible,
                callback: function($$v) {
                  _vm.isSwapDialogVisible = $$v
                },
                expression: "isSwapDialogVisible"
              }
            },
            [
              _c(
                "v-flex",
                [
                  _c("swap-confirmation", {
                    attrs: {
                      swapParams: _vm.swapParams,
                      isEditable: _vm.unit.isStayEditingAllowed,
                      onCancel: _vm.closeSwapDialog,
                      onSwap: _vm.swapStays
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _c(
        "v-menu",
        {
          attrs: {
            "position-x": _vm.x,
            "position-y": _vm.y,
            absolute: "",
            "offset-y": ""
          },
          model: {
            value: _vm.isContextMenuVisible,
            callback: function($$v) {
              _vm.isContextMenuVisible = $$v
            },
            expression: "isContextMenuVisible"
          }
        },
        [
          _c(
            "v-list",
            [
              _c(
                "v-list-tile",
                {
                  on: {
                    click: function($event) {
                      _vm.showStayDialog()
                    }
                  }
                },
                [_vm._v("Edit Stay")]
              ),
              _vm.unit.isRemoveStayAllowed
                ? _c(
                    "v-list-tile",
                    {
                      on: {
                        click: function($event) {
                          _vm.showRemoveStayDialog()
                        }
                      }
                    },
                    [_vm._v("Remove Stay")]
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }